import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalV3 = _resolveComponent("ModalV3")!

  return (_openBlock(), _createBlock(_component_ModalV3, {
    modelValue: _ctx.modelValue,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.modelValue = $event)),
    image: _ctx.image,
    title: _ctx.modalTitle,
    message: _ctx.modalMessageHtml,
    textCancel: _ctx.modalTextCancel,
    textSuccess: _ctx.modalTextSuccess,
    onSubmit: _ctx.onConfirm,
    onClose: _ctx.onCloseModal
  }, null, 8, ["modelValue", "image", "title", "message", "textCancel", "textSuccess", "onSubmit", "onClose"]))
}